import { useEffect } from 'react';

import { trackUserIdentity } from '@/lib/gtm';
import useAuthStore from '@/stores/auth';

export const useGtmAuth = () => {
  const authCompleted = useAuthStore(({ authCompleted }) => authCompleted);
  const currentUser = useAuthStore(({ currentUser }) => currentUser);

  useEffect(() => {
    if (!authCompleted || !currentUser?.id) {
      return;
    }

    trackUserIdentity(currentUser.id, currentUser.belt ?? null);
  }, [authCompleted, currentUser]);
};
